// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".billing_root__ZBfjB {\n  width: 100%;\n  background: #fff;\n  height: 100%;\n  padding: 0 20px;\n  box-sizing: border-box; }\n", ""]);
// Exports
exports.locals = {
	"root": "billing_root__ZBfjB"
};
module.exports = exports;
